import { createContext } from 'react';
import type { Services } from './types';

export const ServicesContext = createContext<undefined | Services>(undefined);

ServicesContext.displayName = 'ServicesContext';
